import { tsValidateBoolean, tsValidateMustExist, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { providers } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
export const DataInputLog_SourceTypes = ['epic-fhir', 'epic-sql', 'physician', 'demo2.0-data'];
const Validator_ModifiableProps = {
    patientId: tsValidateUniqueId,
    encounterId: tsValidateUniqueId,
    source: tsValidateValue(DataInputLog_SourceTypes),
    provider: tsValidateValue([...providers]),
    result: tsValidateMustExist,
    rawQuery: tsValidateMustExist,
    _parsingFailed: tsValidateBoolean(false),
};
const Validator_GeneratedProps = {};
export const DBDef_DataInputLog = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'data-input-logs',
    entityName: 'data-input-log',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'data-input-log'
    },
    backend: {
        name: 'data-input-logs'
    }
};
//# sourceMappingURL=db-def.js.map